<template>
  <div class="container">
    <el-page-header class="page-header" @back="goBack" content="认证结果"></el-page-header>
    <img :src="imgPath"/>
    <span style="margin-top: 30px;
    font-size: 20px;
    color: #666666;
    margin-bottom: 40px;">{{statusText}}</span>
    <span v-show="status == '5'" class="fail-reason">失败原因：{{remark}}</span>
    <el-button v-show="status == '5'" class="button" type="primary" round @click="reApply">再次申请</el-button>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        status: '',
        imgPath:'',
        statusText:'',
        remark:''
      }
    },
    created() {
      this.axios.defaults.headers.common['appType'] = 'pc'
      this.axios.get('/api/getInfo',{params:{}})
      .then((res)=>{
          var data = res.data
          if(data.code == 200){
            this.$store.commit('updateUserInfo',data)
            this.status = data.doctor.status
            this.remark = data.doctor.remark
            if(this.status == '5'){
              this.imgPath = '../../../static/image/ic_check_fail.png'
              this.statusText = '审核失败！'
            }else if(this.status == '4'){
              this.imgPath = '../../../static/image/ic_checking.png'
              this.statusText = '正在审核中...'
            }else if(this.status == '0'){
              this.imgPath = '../../../static/image/ic_apply_success.png'
              this.statusText = '审核成功，您现在已经是医生了！'
            }
          }else if(data.code == 401){
            this.$cookies.remove('token')
            sessionStorage.clear()
            this.$store.commit('updateUserInfo',{})
            vm.$router.push('/Login')
          }else {
            this.$message({
                message:(data.msg&&data.msg.length > 0)?data.msg:'获取账户异常，请联系管理员',
                type:'error'
            })
          }
      }).catch((err)=>{
          console.log(err)
      })
    },
    methods:{
      goBack(){
          if(!this.utils.isEmptyStr(this.fromPath) && this.fromPath != '/'){
              this.$router.go(-1)
          }else{
              this.$router.replace('/')
          }
      },
      reApply(){
        this.$router.replace('/apply')
      }
    },
    beforeRouteEnter(to,from,next){
        next(vm =>{
            vm.fromPath = from.path
        })
    }
  }
</script>

<style scoped>
  .container{
      width: 1000px;
      height: auto;
      display: flex;
      margin: 0px auto;
      flex-direction: column;
      align-items: center;
      overflow: auto;
  }
  .page-header{
      width: 1000px;
      margin-top: 30px;
      color: #333333;
      font-size: 20px;
  }
  .page-header >>> div{
      color:#333333;
      font-size: 20px;
  }
  .container>img{
    width: 128px;
    height: 128px;
    margin-top: 50px;
  }
  .button{
    width: 150px;
    height: 45px;
    margin-top: 40px;
    margin-bottom: 50px;
  }
  .fail-reason{
    color: red;
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/account/applying.vue